import cx from 'classnames';

import { Icon, Text } from '../../common/components';
import { t } from '../../common/i18n';
import { ServicePartnerKind } from '../types';

const namespace = 'OtherServices';

interface PartnerKindBadgeProps {
  kind: ServicePartnerKind;
  /** Klik otevře vysvětlení „Co znamená prověřený partner" (jen u partnerů). */
  onExplain?: () => void;
  className?: string;
}

export const PartnerKindBadge: React.FC<PartnerKindBadgeProps> = ({ kind, onExplain, className }) => {
  const content = (
    <>
      <Icon name={kind === 'partner' ? 'shieldCheck' : 'logo'} />
      <Text as="span" size="body-xs" weight="600">
        {t(`Badge.${kind}`, namespace)}
      </Text>
    </>
  );

  if (kind === 'partner' && onExplain) {
    return (
      <button type="button" className={cx('PartnerKindBadge', `PartnerKindBadge--${kind}`, 'PartnerKindBadge--button', className)} onClick={onExplain}>
        {content}
      </button>
    );
  }

  return <div className={cx('PartnerKindBadge', `PartnerKindBadge--${kind}`, className)}>{content}</div>;
};

export default PartnerKindBadge;
